<template>
  <div>

    <section class="content">
      <div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-cyan" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-3 searching">
                        <span class="h_page">Verifikasi Instrumen KS/Bendahara</span> <br> <br>
                    </div>
                    <div class="col-md-6">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button type="button" class="btn bg-orange btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" @keyup="cari_data" v-model="cari_value">
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->
                <br>
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-info">
                            <th class="text-center" style="width: 5%">No.</th>
                            <th style="width: 20%">Nama Responden</th>
                            <th style="width: 20%">Jabatan</th>
                            <th style="width: 30%">Sekolah</th>
                            <th style="width: 10%">Status</th>
                            <th style="width: 15%">#</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.id">
                            <td class="text-center" :style="cekStatus(data.status)">{{index+1}}.</td>
                            <td>{{data.profile_id.profile.nama}}</td>
                            <td>{{data.profile_id.profile.jabatan}}</td>
                            <td>{{data.sekolah.type}} {{data.sekolah.status}} {{data.sekolah.sekolah}}</td>
                            <td>{{data.status}}</td>
                            <td class="text-center" >
                              <button class="btn bg-light-blue btn-xs waves-effect" @click="viewData(data.data_id)" title="Lihat Data" data-toggle="modal" data-target="#m_lihat_data">
                                  <i class="material-icons" >search</i>
                              </button>
                              <button class="btn bg-light-green btn-xs waves-effect" @click="viewId(data.data_id)" title="Setujui Data" data-toggle="modal" data-target="#m_setujui_data">
                                  <i class="material-icons" >done</i>
                              </button>
                              <button class="btn bg-red btn-xs waves-effect" @click="viewId(data.data_id)" title="Kembalikan Data" data-toggle="modal" data-target="#m_kembalikan_data">
                                  <i class="material-icons" >clear</i>
                              </button>
                            </td>
                        </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>

                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>

                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_setujui_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan penilaian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>



                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="setujuiData" class="btn btn-success waves-effect">SETUJUI</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL SETUJUI xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_kembalikan_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-deep-orange">
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                                <div class="modal-body">

                                  <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                      <label for="kode">Saran Petugas</label>
                                    </div>
                                    <div class="col-md-10">
                                      <div class="form-group">
                                        <div class="form-line">
                                          <textarea rows="4" v-model="saran" class="form-control no-resize" placeholder="Isi dengan keterangan pengembalian anda..."></textarea>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" @click="kembalikanData" class="btn bg-deep-orange waves-effect">KEMBALIKAN</button>
                                    <button type="button" class="btn bg-red waves-effect" data-dismiss="modal">BATAL</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL KEMBALIKAN xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_lihat_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <h4 class="modal-title" id="largeModalLabel">DETIL DATA</h4>
                                </div>
                                <div class="modal-body">
                                  <div class="table-responsive" >
                                    <h4>A.	PESERTA DIDIK</h4> <br>
                                    <!-- ========================================== 1.	Jumlah Peserta Didik =========================================== -->
                                      <span class="h_tabel_title">1.	Jumlah Peserta Didik</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th style="width: 17%" class="text-center">PD Tk. 10</th>
                                            <th style="width: 17%" class="text-center">PD Tk. 10</th>
                                            <th style="width: 17%" class="text-center">PD Tk. 11</th>
                                            <th style="width: 17%" class="text-center">PD Tk. 11</th>
                                            <th style="width: 17%" class="text-center">PD Tk. 12</th>
                                            <th style="width: 15%" class="text-center">PD Tk. 12</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{A1_1}}</td>
                                            <td>{{A1_2}}</td>
                                            <td>{{A1_3}}</td>
                                            <td>{{A1_4}}</td>
                                            <td>{{A1_5}}</td>
                                            <td>{{A1_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="7"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 1.	Jumlah Peserta Didik =========================================== -->

                                    <!-- ========================================== 2.	Jumlah Rombongan Belajar =========================================== -->
                                      <span class="h_tabel_title">2.	Jumlah Rombongan Belajar</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th style="width: 33%" class="text-center">Rombel Tingkat 10</th>
                                            <th style="width: 33%" class="text-center">Rombel Tingkat 11</th>
                                            <th style="width: 34%" class="text-center">Rombel Tingkat 12</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{A2_1}}</td>
                                            <td>{{A2_2}}</td>
                                            <td>{{A2_3}}</td>
                                          </tr>

                                          <tr style="background:#e3e4e5"><td colspan="4"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 2.	Jumlah Rombongan Belajar =========================================== -->

                                    <hr><h4>B.	PENDIDIK DAN TENAGA KEPENDIDIKAN</h4> <br>
                                    <!-- ========================================== 1.	Jumlah Pendidik dan Tenaga Kependidikan =========================================== -->
                                      <span class="h_tabel_title">1.	Jumlah Pendidik dan Tenaga Kependidikan</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="2">Pendidik  / Guru</th>
                                            <th class="text-center" colspan="2">Staf / Tenaga Administrasi</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 25%" class="text-center" >PNS</th>
                                            <th style="width: 25%" class="text-center" >NonPNS</th>
                                            <th style="width: 25%" class="text-center" >PNS</th>
                                            <th style="width: 25%" class="text-center" >NonPNS</th>

                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{B1_1}}</td>
                                            <td>{{B1_2}}</td>
                                            <td>{{B1_3}}</td>
                                            <td>{{B1_4}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="5"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 1.	Jumlah Pendidik dan Tenaga Kependidikan =========================================== -->

                                    <hr><h4>C.	PRASARANA / RUANG</h4> <br>
                                    <!-- ========================================== 1.	Ruang Kelas =========================================== -->
                                      <span class="h_tabel_title">1.	Ruang Kelas</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C1_1}}</td>
                                            <td>{{C1_2}}</td>
                                            <td>{{C1_3}}</td>
                                            <td>{{C1_4}}</td>
                                            <td>{{C1_5}}</td>
                                            <td>{{C1_7}}</td>
                                            <td>{{C1_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 1.	Ruang Kelas =========================================== -->

                                    <!-- ========================================== 2.	Perpustakaan =========================================== -->
                                      <span class="h_tabel_title">2.	Perpustakaan</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C2_1}}</td>
                                            <td>{{C2_2}}</td>
                                            <td>{{C2_3}}</td>
                                            <td>{{C2_4}}</td>
                                            <td>{{C2_5}}</td>
                                            <td>{{C2_7}}</td>
                                            <td>{{C2_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 2.	Perpustakaan =========================================== -->

                                    <!-- ========================================== 3.	Lab IPA =========================================== -->
                                      <span class="h_tabel_title">3.	Lab IPA</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C3_1}}</td>
                                            <td>{{C3_2}}</td>
                                            <td>{{C3_3}}</td>
                                            <td>{{C3_4}}</td>
                                            <td>{{C3_5}}</td>
                                            <td>{{C3_7}}</td>
                                            <td>{{C3_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 3.	Lab IPA =========================================== -->

                                    <!-- ========================================== 4.	Lab Kimia =========================================== -->
                                      <span class="h_tabel_title">4.	Lab Kimia</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C4_1}}</td>
                                            <td>{{C4_2}}</td>
                                            <td>{{C4_3}}</td>
                                            <td>{{C4_4}}</td>
                                            <td>{{C4_5}}</td>
                                            <td>{{C4_7}}</td>
                                            <td>{{C4_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 4.	Lab Kimia =========================================== -->

                                    <!-- ========================================== 5.	Lab Fisika =========================================== -->
                                      <span class="h_tabel_title">5.	Lab Fisika</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C5_1}}</td>
                                            <td>{{C5_2}}</td>
                                            <td>{{C5_3}}</td>
                                            <td>{{C5_4}}</td>
                                            <td>{{C5_5}}</td>
                                            <td>{{C5_7}}</td>
                                            <td>{{C5_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 5.	Lab Fisika =========================================== -->

                                    <!-- ========================================== 6.	Lab Biologi =========================================== -->
                                      <span class="h_tabel_title">6.	Lab Biologi</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C6_1}}</td>
                                            <td>{{C6_2}}</td>
                                            <td>{{C6_3}}</td>
                                            <td>{{C6_4}}</td>
                                            <td>{{C6_5}}</td>
                                            <td>{{C6_7}}</td>
                                            <td>{{C6_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 6.	Lab Biologi =========================================== -->

                                    <!-- ========================================== 7.	Lab Bahasa =========================================== -->
                                      <span class="h_tabel_title">7.	Lab Bahasa</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C7_1}}</td>
                                            <td>{{C7_2}}</td>
                                            <td>{{C7_3}}</td>
                                            <td>{{C7_4}}</td>
                                            <td>{{C7_5}}</td>
                                            <td>{{C7_7}}</td>
                                            <td>{{C7_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 7.	Lab Bahasa =========================================== -->

                                    <!-- ========================================== 8.	Lab IPS =========================================== -->
                                      <span class="h_tabel_title">8.	Lab IPS</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C8_1}}</td>
                                            <td>{{C8_2}}</td>
                                            <td>{{C8_3}}</td>
                                            <td>{{C8_4}}</td>
                                            <td>{{C8_5}}</td>
                                            <td>{{C8_7}}</td>
                                            <td>{{C8_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 8.	Lab IPS =========================================== -->

                                    <!-- ========================================== 9.	Lab Komputer =========================================== -->
                                      <span class="h_tabel_title">9.	Lab Komputer</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C9_1}}</td>
                                            <td>{{C9_2}}</td>
                                            <td>{{C9_3}}</td>
                                            <td>{{C9_4}}</td>
                                            <td>{{C9_5}}</td>
                                            <td>{{C9_7}}</td>
                                            <td>{{C9_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 9.	Lab Komputer =========================================== -->

                                    <!-- ========================================== 10.	UKS =========================================== -->
                                      <span class="h_tabel_title">10.	UKS</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C10_1}}</td>
                                            <td>{{C10_2}}</td>
                                            <td>{{C10_3}}</td>
                                            <td>{{C10_4}}</td>
                                            <td>{{C10_5}}</td>
                                            <td>{{C10_7}}</td>
                                            <td>{{C10_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 10.	UKS =========================================== -->

                                    <!-- ========================================== 11.	WC Guru Laki-laki =========================================== -->
                                      <span class="h_tabel_title">11.	WC Guru Laki-laki</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C11_1}}</td>
                                            <td>{{C11_2}}</td>
                                            <td>{{C11_3}}</td>
                                            <td>{{C11_4}}</td>
                                            <td>{{C11_5}}</td>
                                            <td>{{C11_7}}</td>
                                            <td>{{C11_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 11.	WC Guru Laki-laki =========================================== -->

                                    <!-- ========================================== 12.	WC Guru Perempuan =========================================== -->
                                      <span class="h_tabel_title">12.	WC Guru Perempuan</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C12_1}}</td>
                                            <td>{{C12_2}}</td>
                                            <td>{{C12_3}}</td>
                                            <td>{{C12_4}}</td>
                                            <td>{{C12_5}}</td>
                                            <td>{{C12_7}}</td>
                                            <td>{{C12_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 12.	WC Guru Perempuan =========================================== -->

                                    <!-- ========================================== 13.	WC Siswa Laki-laki =========================================== -->
                                      <span class="h_tabel_title">13.	WC Siswa Laki-laki</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C13_1}}</td>
                                            <td>{{C13_2}}</td>
                                            <td>{{C13_3}}</td>
                                            <td>{{C13_4}}</td>
                                            <td>{{C13_5}}</td>
                                            <td>{{C13_7}}</td>
                                            <td>{{C13_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 13.	WC Siswa Laki-laki =========================================== -->

                                    <!-- ========================================== 14.	WC Siswa Perempuan =========================================== -->
                                      <span class="h_tabel_title">14.	WC Siswa Perempuan</span> <br><br>
                                      <table class="table table-bordered" style="width: 100%">
                                        <thead>
                                          <tr class="bg-grey">
                                            <th class="text-center" colspan="5">JENIS KERUSAKAN</th>
                                            <th style="width: 20%; vertical-align: middle;" class="text-center" rowspan="2">JUMLAH</th>
                                            <th style="width: 30%; vertical-align: middle;" class="text-center" rowspan="2">KET</th>
                                          </tr>
                                          <tr class="bg-grey">
                                            <th style="width: 10%" class="text-center" >BAIK</th>
                                            <th style="width: 10%" class="text-center" >RINGAN</th>
                                            <th style="width: 10%" class="text-center" >SEDANG</th>
                                            <th style="width: 10%" class="text-center" >BERAT</th>
                                            <th style="width: 10%" class="text-center" >TOTAL</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          <tr class="h_isitable">
                                            <td>{{C14_1}}</td>
                                            <td>{{C14_2}}</td>
                                            <td>{{C14_3}}</td>
                                            <td>{{C14_4}}</td>
                                            <td>{{C14_5}}</td>
                                            <td>{{C14_7}}</td>
                                            <td>{{C14_6}}</td>
                                          </tr>
                                          <tr style="background:#e3e4e5"><td colspan="8"></td></tr>
                                        </tbody>
                                      </table>
                                    <!-- ========================================== 14.	WC Siswa Perempuan =========================================== -->




                                  </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL LIHAT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->

                <!-- ============================================================ MODAL ======================================================================== -->



        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>




      </div>
    </section>
  </div>
</template>


<script>

const ADD_URL = URL_APP+'api/v1/ver_instrumen_verifikasi_dapodik_SMA/';


export default {
  name: "monev_ver_instrumen_verifikasi_dapodik_sma",
  data() {
    return {
      data_id : '',
      // ============= A_1 =================
        A1_kondisi: true,
        A1_counter: false,
        A1_id : '',
        A1_1 : '',
        A1_2 : '',
        A1_3 : '',
        A1_4 : '',
        A1_5 : '',
        A1_6 : '',

      // ============= A_1 =================

      // ============= A_2 =================
        A2_kondisi: true,
        A2_counter: false,
        A2_id : '',
        A2_1 : '',
        A2_2 : '',
        A2_3 : '',
      // ============= A_2 =================

      // ============= B_1 =================
        B1_kondisi: true,
        B1_counter: false,
        B1_id : '',
        B1_1 : '',
        B1_2 : '',
        B1_3 : '',
        B1_4 : '',
      // ============= B_1 =================

      // ============= C_1 =================
        C1_kondisi: true,
        C1_counter: false,
        C1_id : '',
        C1_1 : '',
        C1_2 : '',
        C1_3 : '',
        C1_4 : '',
        C1_5 : '',
        C1_6 : '',
      // ============= C_1 =================

      // ============= C_2 =================
        C2_kondisi: true,
        C2_counter: false,
        C2_id : '',
        C2_1 : '',
        C2_2 : '',
        C2_3 : '',
        C2_4 : '',
        C2_5 : '',
        C2_6 : '',
      // ============= C_2 =================

      // ============= C_3 =================
        C3_kondisi: true,
        C3_counter: false,
        C3_id : '',
        C3_1 : '',
        C3_2 : '',
        C3_3 : '',
        C3_4 : '',
        C3_5 : '',
        C3_6 : '',
      // ============= C_3 =================

      // ============= C_4 =================
        C4_kondisi: true,
        C4_counter: false,
        C4_id : '',
        C4_1 : '',
        C4_2 : '',
        C4_3 : '',
        C4_4 : '',
        C4_5 : '',
        C4_6 : '',
      // ============= C_4 =================

      // ============= C_5 =================
        C5_kondisi: true,
        C5_counter: false,
        C5_id : '',
        C5_1 : '',
        C5_2 : '',
        C5_3 : '',
        C5_4 : '',
        C5_5 : '',
        C5_6 : '',
      // ============= C_5 =================

      // ============= C_6 =================
        C6_kondisi: true,
        C6_counter: false,
        C6_id : '',
        C6_1 : '',
        C6_2 : '',
        C6_3 : '',
        C6_4 : '',
        C6_5 : '',
        C6_6 : '',
      // ============= C_6 =================

      // ============= C_7 =================
        C7_kondisi: true,
        C7_counter: false,
        C7_id : '',
        C7_1 : '',
        C7_2 : '',
        C7_3 : '',
        C7_4 : '',
        C7_5 : '',
        C7_6 : '',
      // ============= C_7 =================

      // ============= C_8 =================
        C8_kondisi: true,
        C8_counter: false,
        C8_id : '',
        C8_1 : '',
        C8_2 : '',
        C8_3 : '',
        C8_4 : '',
        C8_5 : '',
        C8_6 : '',
      // ============= C_2 =================

      // ============= C_9 =================
        C9_kondisi: true,
        C9_counter: false,
        C9_id : '',
        C9_1 : '',
        C9_2 : '',
        C9_3 : '',
        C9_4 : '',
        C9_5 : '',
        C9_6 : '',
      // ============= C_9 =================

      // ============= C_10 =================
        C10_kondisi: true,
        C10_counter: false,
        C10_id : '',
        C10_1 : '',
        C10_2 : '',
        C10_3 : '',
        C10_4 : '',
        C10_5 : '',
        C10_6 : '',
      // ============= C_10 =================

      // ============= C_11 =================
        C11_kondisi: true,
        C11_counter: false,
        C11_id : '',
        C11_1 : '',
        C11_2 : '',
        C11_3 : '',
        C11_4 : '',
        C11_5 : '',
        C11_6 : '',
      // ============= C_11 =================

      // ============= C_12 =================
        C12_kondisi: true,
        C12_counter: false,
        C12_id : '',
        C12_1 : '',
        C12_2 : '',
        C12_3 : '',
        C12_4 : '',
        C12_5 : '',
        C12_6 : '',
      // ============= C_12 =================

      // ============= C_13 =================
        C13_kondisi: true,
        C13_counter: false,
        C13_id : '',
        C13_1 : '',
        C13_2 : '',
        C13_3 : '',
        C13_4 : '',
        C13_5 : '',
        C13_6 : '',
      // ============= C_13 =================

      // ============= C_13 =================
        C14_kondisi: true,
        C14_counter: false,
        C14_id : '',
        C14_1 : '',
        C14_2 : '',
        C14_3 : '',
        C14_4 : '',
        C14_5 : '',
        C14_6 : '',
      // ============= C_13 =================

      saran : '',

      list_data: [],
      page_first: 1,
      page_last: 0,
      cari_value: "",
    };
  },

// =============================================================== METHODS =========================================================================
  methods : {
    getData : function(){
      fetch(ADD_URL+'view', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: this.cari_value
        })
      }).then(res => res.json())
        .then((data_res) => {
          this.list_data = data_res.data;
          this.page_last = data_res.jml_data
          // console.log(this.list_data);
        })
    },

    viewId : function(data_id){
      this.data_id = data_id
    },

    setujuiData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'diterima',

        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });
    },

    kembalikanData : function(){
      fetch(ADD_URL+'setujui', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : 'kikensbatara '+ localStorage.token,
        },
        body : JSON.stringify({
          data_id : this.data_id,
          saran : this.saran,
          status : 'dikembalikan',
        })
      }).then((res_data)=>{
        this.alertku("success", "Data Sukses disetujui");
        this.getData();
      });

    },

    viewData : function(data_cari){
      fetch(ADD_URL+'view_one', {
        method : 'POST',
        headers : {
          'content-type' : 'application/json',
          authorization : "kikensbatara "+ localStorage.token
        },
        body : JSON.stringify({
          data_ke: this.page_first,
          cari_value: data_cari,
        })
      }).then(res => res.json())
        .then((data_res) => {

          var response = data_res[0];

          // console.log(response);

          // ============= A_1 =================
                this.A1_1 = response.A1_1;
                this.A1_2 = response.A1_2;
                this.A1_3 = response.A1_3;
                this.A1_4 = response.A1_4;
                this.A1_5 = response.A1_5;
                this.A1_6 = response.A1_6;
              // ============= A_1 =================

              // ============= A_2 =================
                this.A2_1 = response.A2.A2_1;
                this.A2_2 = response.A2.A2_2;
                this.A2_3 = response.A2.A2_3;
              // ============= A_2 =================

              // ============= B_1 =================
                this.B1_1 = response.B1.B1_1;
                this.B1_2 = response.B1.B1_2;
                this.B1_3 = response.B1.B1_3;
                this.B1_4 = response.B1.B1_4;
              // ============= B_1 =================

              // ============= C_1 =================
                this.C1_1 = response.C1.C1_1;
                this.C1_2 = response.C1.C1_2;
                this.C1_3 = response.C1.C1_3;
                this.C1_4 = response.C1.C1_4;
                this.C1_5 = response.C1.C1_5;
                this.C1_6 = response.C1.C1_6;
              // ============= C_1 =================

              // ============= C_2 =================
                this.C2_1 = response.C2.C2_1;
                this.C2_2 = response.C2.C2_2;
                this.C2_3 = response.C2.C2_3;
                this.C2_4 = response.C2.C2_4;
                this.C2_5 = response.C2.C2_5;
                this.C2_6 = response.C2.C2_6;
              // ============= C_2 =================

              // ============= C_3 =================
                this.C3_1 = response.C3.C3_1;
                this.C3_2 = response.C3.C3_2;
                this.C3_3 = response.C3.C3_3;
                this.C3_4 = response.C3.C3_4;
                this.C3_5 = response.C3.C3_5;
                this.C3_6 = response.C3.C3_6;
              // ============= C_3 =================

              // ============= C_4 =================
                this.C4_1 = response.C4.C4_1;
                this.C4_2 = response.C4.C4_2;
                this.C4_3 = response.C4.C4_3;
                this.C4_4 = response.C4.C4_4;
                this.C4_5 = response.C4.C4_5;
                this.C4_6 = response.C4.C4_6;
              // ============= C_4 =================

              // ============= C_5 =================
                this.C5_1 = response.C5.C5_1;
                this.C5_2 = response.C5.C5_2;
                this.C5_3 = response.C5.C5_3;
                this.C5_4 = response.C5.C5_4;
                this.C5_5 = response.C5.C5_5;
                this.C5_6 = response.C5.C5_6;
              // ============= C_5 =================

              // ============= C_6 =================
                this.C6_1 = response.C6.C6_1;
                this.C6_2 = response.C6.C6_2;
                this.C6_3 = response.C6.C6_3;
                this.C6_4 = response.C6.C6_4;
                this.C6_5 = response.C6.C6_5;
                this.C6_6 = response.C6.C6_6;
              // ============= C_6 =================

              // ============= C_7 =================
                this.C7_1 = response.C7.C7_1;
                this.C7_2 = response.C7.C7_2;
                this.C7_3 = response.C7.C7_3;
                this.C7_4 = response.C7.C7_4;
                this.C7_5 = response.C7.C7_5;
                this.C7_6 = response.C7.C7_6;
              // ============= C_7 =================

              // ============= C_8 =================
                this.C8_1 = response.C8.C8_1;
                this.C8_2 = response.C8.C8_2;
                this.C8_3 = response.C8.C8_3;
                this.C8_4 = response.C8.C8_4;
                this.C8_5 = response.C8.C8_5;
                this.C8_6 = response.C8.C8_6;
              // ============= C_2 =================

              // ============= C_9 =================
                this.C9_1 = response.C9.C9_1;
                this.C9_2 = response.C9.C9_2;
                this.C9_3 = response.C9.C9_3;
                this.C9_4 = response.C9.C9_4;
                this.C9_5 = response.C9.C9_5;
                this.C9_6 = response.C9.C9_6;
              // ============= C_9 =================

              // ============= C_10 =================
                this.C10_1 = response.C10.C10_1;
                this.C10_2 = response.C10.C10_2;
                this.C10_3 = response.C10.C10_3;
                this.C10_4 = response.C10.C10_4;
                this.C10_5 = response.C10.C10_5;
                this.C10_6 = response.C10.C10_6;
              // ============= C_10 =================

              // ============= C_11 =================
                this.C11_1 = response.C11.C11_1;
                this.C11_2 = response.C11.C11_2;
                this.C11_3 = response.C11.C11_3;
                this.C11_4 = response.C11.C11_4;
                this.C11_5 = response.C11.C11_5;
                this.C11_6 = response.C11.C11_6;
              // ============= C_11 =================

              // ============= C_12 =================
                this.C12_1 = response.C12.C12_1;
                this.C12_2 = response.C12.C12_2;
                this.C12_3 = response.C12.C12_3;
                this.C12_4 = response.C12.C12_4;
                this.C12_5 = response.C12.C12_5;
                this.C12_6 = response.C12.C12_6;
              // ============= C_12 =================

              // ============= C_13 =================
                this.C13_1 = response.C13.C13_1;
                this.C13_2 = response.C13.C13_2;
                this.C13_3 = response.C13.C13_3;
                this.C13_4 = response.C13.C13_4;
                this.C13_5 = response.C13.C13_5;
                this.C13_6 = response.C13.C13_6;
              // ============= C_13 =================

              // ============= C_13 =================
                this.C14_1 = response.C14.C14_1;
                this.C14_2 = response.C14.C14_2;
                this.C14_3 = response.C14.C14_3;
                this.C14_4 = response.C14.C14_4;
                this.C14_5 = response.C14.C14_5;
                this.C14_6 = response.C14.C14_6;
              // ============= C_13 =================


          this.saran = response.saran;

        })
    },

    cekStatus : function(data){
      if(data == 'diterima'){
        return {background : '#e4ffc4'}
      }
      else if (data == 'dikembalikan') {
        return {background : '#ffcece'}
      }
    },

// ================== PAGINASI ====================
    alertku: function(type, title) {
      this.$swal({
        type: type,
        title: title,
        showConfirmButton: false,
        timer: 800
      });
    },

    btn_prev: function() {
      if (this.page_first > 1) {
        this.page_first--;
      } else {
        this.page_first = 1;
      }
      this.getData();
    },

    btn_next: function() {
      if (this.page_first >= this.page_last) {
        this.page_first == this.page_last;
      } else {
        this.page_first++;
      }
      this.getData();
    },

    cari_data: function() {
      this.getData();
    },
// ================== PAGINASI ====================



  },
// =============================================================== METHODS =========================================================================

  mounted() {
    this.getData();
  },
  computed: {

    ket_16_selesaix : function(){
      return parseFloat(this.ket_16_selesai_01)+ parseFloat(this.ket_16_selesai_02) + parseFloat(this.ket_16_selesai_03) + parseFloat(this.ket_16_selesai_04)
    },
    ket_16_belumx : function(){
      return parseFloat(this.ket_16_belum_01)+ parseFloat(this.ket_16_belum_02) + parseFloat(this.ket_16_belum_03) + parseFloat(this.ket_16_belum_04)
    },
    ket_16_masukx : function(){
      return parseFloat(this.ket_16_masuk_01)+ parseFloat(this.ket_16_masuk_02) + parseFloat(this.ket_16_masuk_03) + parseFloat(this.ket_16_masuk_04)
    },

    C1_7 : function(){return this.C1_1 + this.C1_2 + this.C1_3 + this.C1_4 + this.C1_5},
    C2_7 : function(){return this.C2_1 + this.C2_2 + this.C2_3 + this.C2_4 + this.C2_5},
    C3_7 : function(){return this.C3_1 + this.C3_2 + this.C3_3 + this.C3_4 + this.C3_5},
    C4_7 : function(){return this.C4_1 + this.C4_2 + this.C4_3 + this.C4_4 + this.C4_5},
    C5_7 : function(){return this.C5_1 + this.C5_2 + this.C5_3 + this.C5_4 + this.C5_5},
    C6_7 : function(){return this.C6_1 + this.C6_2 + this.C6_3 + this.C6_4 + this.C6_5},
    C7_7 : function(){return this.C7_1 + this.C7_2 + this.C7_3 + this.C7_4 + this.C7_5},
    C8_7 : function(){return this.C8_1 + this.C8_2 + this.C8_3 + this.C8_4 + this.C8_5},
    C9_7 : function(){return this.C9_1 + this.C9_2 + this.C9_3 + this.C9_4 + this.C9_5},
    C10_7 : function(){return this.C10_1 + this.C10_2 + this.C10_3 + this.C10_4 + this.C10_5},
    C11_7 : function(){return this.C11_1 + this.C11_2 + this.C11_3 + this.C11_4 + this.C11_5},
    C12_7 : function(){return this.C12_1 + this.C12_2 + this.C12_3 + this.C12_4 + this.C12_5},
    C13_7 : function(){return this.C13_1 + this.C13_2 + this.C13_3 + this.C13_4 + this.C13_5},
    C14_7 : function(){return this.C14_1 + this.C14_2 + this.C14_3 + this.C14_4 + this.C14_5},
  },
};
</script>


